import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-offline-popup',
  templateUrl: './offline-popup.html',
  styleUrl: './offline-popup.scss',
  standalone: false
})
export class OfflinePopupComponent {
  @Input() visible = false;
  @Output() close = new EventEmitter<void>();

  closePopup(): void {
    this.close.emit();
  }
}
